var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPartThree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 101,
    viewBox: "0 0 90 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6269 44.7703L36.5603 39.6996L60.5557 46.8029L45.2943 54.0756L21.6269 44.7703Z",
    fill: "#6957BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8649 11.4485L77.3637 26.6736L63.0546 46.5162L60.4737 30.3232L76.8649 11.4485Z",
    fill: "#6957BA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.919922 10.082L13.7592 18.9994L21.3576 42.0155L6.44994 34.093L0.919922 10.082Z",
    fill: "#6957BA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5927 1.22949L41.432 10.1469L49.0304 33.163L34.1227 25.2406L28.5927 1.22949Z",
    fill: "#6957BA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.63927 48.7627L22.9408 52.6892L38.5736 71.5852L21.7087 69.2977L7.63927 48.7627Z",
    fill: "#6957BA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4268 91.0017L60.3267 85.8407L84.3681 92.7989L69.1546 100.164L45.4268 91.0017Z",
    fill: "#6957BA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9559 88.2715L42.4423 73.1061L59.221 55.1423L59.6744 71.5186L40.9559 88.2715Z",
    fill: "#6957BA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9161 32.763L88.5463 45.5286L86.9974 69.6272L76.0647 57.0728L79.9161 32.763Z",
    fill: "#6957BA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5732 55.4372L77.796 63.82L86.4075 86.5037L71.1623 79.1997L64.5732 55.4372Z",
    fill: "#6957BA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6269 44.7703L36.5603 39.6996L60.5557 46.8029L45.2943 54.0756L21.6269 44.7703Z",
    stroke: "#6957BA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8649 11.4485L77.3637 26.6736L63.0546 46.5162L60.4737 30.3232L76.8649 11.4485Z",
    stroke: "#6957BA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0.919922 10.082L13.7592 18.9994L21.3576 42.0155L6.44994 34.093L0.919922 10.082Z",
    stroke: "#6957BA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5927 1.22949L41.432 10.1469L49.0304 33.163L34.1227 25.2406L28.5927 1.22949Z",
    stroke: "#6957BA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.63927 48.7627L22.9408 52.6892L38.5736 71.5852L21.7087 69.2977L7.63927 48.7627Z",
    stroke: "#6957BA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4268 91.0017L60.3267 85.8407L84.3681 92.7989L69.1546 100.164L45.4268 91.0017Z",
    stroke: "#6957BA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9559 88.2715L42.4423 73.1061L59.221 55.1423L59.6744 71.5186L40.9559 88.2715Z",
    stroke: "#6957BA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9161 32.763L88.5463 45.5286L86.9974 69.6272L76.0647 57.0728L79.9161 32.763Z",
    stroke: "#6957BA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5732 55.4372L77.796 63.82L86.4075 86.5037L71.1623 79.1997L64.5732 55.4372Z",
    stroke: "#6957BA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartThree);
export default __webpack_public_path__ + "static/media/part-three.87d2b9e3a02f8dcc80c93575a1fad71d.svg";
export { ForwardRef as ReactComponent };